export default "__VITE_ASSET__CjyOQ3qN__"